"use strict"

import React from "react"

const ConfigContext = React.createContext({})

export function withCrossHairConfig(Component) {
  return function (props) {
    return (
      <ConfigContext.Consumer>
        {(configData) => <Component {...props} {...configData} />}
      </ConfigContext.Consumer>
    )
  }
}

export default class CrossHairConfigProvider extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      crossHairTime: undefined,
      crossHairCurrentGraph: undefined,
      crossHairValue: undefined,
    }

    this.updateCrossHairs = this.updateCrossHairs.bind(this)
  }

  render() {
    return (
      <ConfigContext.Provider
        value={{
          crossHairTimes: this.state.crossHairTimes,
          crossHairCurrentGraph: this.state.crossHairCurrentGraph,
          crossHairValues: this.state.crossHairValues,
          updateCrossHairs: this.updateCrossHairs,
        }}
      >
        {this.props.children}
      </ConfigContext.Provider>
    )
  }

  updateCrossHairs(times, currentGraph, values) {
    this.setState({
      crossHairTimes: times,
      crossHairCurrentGraph: currentGraph,
      crossHairValues: values,
    })
  }
}
